module.exports = __webpack_public_path__ + "img/icon-download.695550dc.svg";